// Migration utility to copy sessionStorage to localStorage
// This ensures existing sessions are preserved during the transition

const migrateAuthData = () => {
  const keys = ['token', 'username', 'email', 'id', 'fullName', 'role'];
  
  keys.forEach(key => {
    const sessionValue = sessionStorage.getItem(key);
    const localValue = localStorage.getItem(key);
    
    // If there's a value in sessionStorage but not in localStorage, migrate it
    if (sessionValue && !localValue) {
      localStorage.setItem(key, sessionValue);
      console.log(`Migrated ${key} from sessionStorage to localStorage`);
    }
  });
};

// Run migration on import
migrateAuthData();

export default migrateAuthData;